import { render, staticRenderFns } from "./RaceInformation.vue?vue&type=template&id=d0a83c10&scoped=true&"
import script from "./RaceInformation.vue?vue&type=script&lang=js&"
export * from "./RaceInformation.vue?vue&type=script&lang=js&"
import style0 from "./RaceInformation.vue?vue&type=style&index=0&id=d0a83c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a83c10",
  null
  
)

export default component.exports